var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta && _vm.$route.meta.authPage)?_c('auth'):_c('default-layout'),_c('notifications',{attrs:{"position":"bottom center"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }